<template>
  <div class="w-screen h-screen dark:bg-gray-900 flex flex-col items-center justify-center">
    <p class="dark:text-indigo-300 text-9xl">404</p>
    <p class="dark:text-gray-300 text-5xl">Página não encontrada</p>
    <p class="dark:text-gray-300 text-lg">Você provavelmente está tentando acessar uma página que não existe</p>
    <p class="dark:text-indigo-300 mt-10 text-3xl">Retornar</p>
  </div>
</template>